<template>
    <div class="ideal-payment-container">
        <div v-if="invoice">
            <b-card v-if="paymentUnavailable">
                <span class="error-message">{{ paymentUnavailableMessage }}</span>
            </b-card>

            <b-row align-h="center">
                <b-col>
                    <h1 style="color: white" v-translate>Payment Request</h1>
                    <b-card>
                        <div class="ideal-logo-container">
                            <img class="ideal-logo" src="/static/images/iDEAL-logo.png"><span v-translate>iDEAL</span>
                        </div>
                        
                        <hr>

                        <p class="field-container"><strong v-translate>Sent by:</strong> {{ company_profile.name }}</p>
                        <p class="field-container"><strong v-translate>Invoice Number:</strong> {{ invoice.number }}</p>
                        <p class="field-container"><strong v-translate>Invoice Amount:</strong> {{ invoice.total_amount | currency('EUR', 2)}}</p>

                        <b-row v-if="!paymentUnavailable" align-h="center">
                            <GekkoButton 
                                :text="$gettext('Pay Now')"
                                @click="onSubmit"
                                class="payment-button"/>
                        </b-row>
                    </b-card>
                </b-col>

                <b-col cols="9">
                    <div class="pdf-preview-wrap">
                        <iframe class="pdf-preview" v-if="invoice" :src="invoice.pdf_file"></iframe>
                    </div>
                </b-col>
            </b-row>
        </div>

        <div v-if="!invoice && !loading">
            <h1 v-translate>Oops this payment request does not seem to exist</h1>
            <div>
                <div v-translate>Please contact the company that send you this link and report that you received this broken link.</div>
            </div>
        </div>
    </div>
</template>

<script>
import MollieService from '@/store/services/idealpayment.service.js'
import GekkoButton from '@/components/GekkoButton'

export default {
    name: "MolliePaymentStart",
    components: {GekkoButton},
    data() {
        return {
            invoice: null,
            company_profile: null,
            paymentUnavailable: false,
            paymentUnavailableMessage: this.$gettext('The direct iDEAL link is currently not setup up correctly. Please contact the sender or try paying manually.'),
            loading: true
        }
    },
    created() {
        let uuid = this.$route.params['uuid']

        MollieService.generateMolliePayment(uuid).then((response) => {
            if (response.status !== 204) {
                this.invoice = response.data.invoice
                this.company_profile = response.data.company_profile
                this.paymentUnavailable = response.data.payment_unavailable
                this.amountToPay = response.invoice.amount_to_be_paid
            } else {
                this.$router.push({ name: 'MolliePaymentComplete',  params: { uuid: uuid} })
            }
            this.loading = false
        }).catch(()=>{ this.loading = false })
    },
    methods: {
        onSubmit() {
            let uuid = this.$route.params['uuid']

            MollieService.mollieCheckoutUrl(uuid).then((response) => {
                if (response.status === 297) {
                    this.paymentUnavailable = true
                    this.paymentUnavailableMessage = response.data.detail
                } else {
                    window.location.href = response.data.url
                }
            }).catch((error) => { // redirects if no errors
                if (error.status === 404) {
                    this.$store.commit('setAlert', {
                        title: this.$gettext('Error'),
                        text: this.$gettext('Payment not found'),
                        variant: 'danger',
                        duration: 4
                    })
                } else {
                    this.$store.commit('setAlert', {
                        title: this.$gettext('Error'),
                        text: this.$gettext('Error creating payment link: Invalid access token'),
                        variant: 'danger',
                        duration: 4
                    })
                }
            })
        }
    }
}
</script>

<style scoped>
.pdf-preview-wrap {
    padding: 0;
    padding-top: 1rem;
    aspect-ratio: 1/1.4142;
    max-width: 800px;
    margin: 0 auto;
}

.pdf-preview {
    height: 100%;
    width: 100%;
    border: 0;
    transition: opacity 0.3s ease;
}

.error-message {
    color: #810911;
    font-style: italic;
}

.ideal-logo {
    width: 45px;
}

.field-container {
    margin-bottom: 10px;
}

.ideal-payment-container {
    padding: 1rem;
    color: #ffffff;

    .row {
        color: #000000;
    }
}

.ideal-logo-container {
    display: flex;
    justify-content: center;
    align-items: center;
}

.payment-button {
    width: 92%;
    margin-bottom: 1rem;
    margin-top: 1rem;
}
</style>